import React, { Component } from 'react';
import './signup.scss';
export default class AdminSignup extends Component {
    state = {
        email: '',
        password: ''
    }

    onEmailChange = (e) => {
        this.setState({
            email: e.target.value
        })
    }
    onChangePassword = (e) => {
        this.setState({
            password: e.target.value
        })
    }

    loginOnKeyPress = () => {
    }
    render() {
        return <div className='admin-signup-holder' style={{ backgroundImage: `url("/images/signup-image.png")` }}>
            <div className='container-fluid signup-form'>
                <div className='col-md-4 offset-md-7'>
                    <div class="trapezium-shape">
                        <div className='login-holder'>
                            <div className='login-box text-center'>
                                <img src='/images/elite-big-logo.svg' alt='' />
                                <p className='text-center'>Unlock learning for you and your organization </p>
                                <div className="form-group mt-4">
                                    <div className="has-search"  >
                                        <span className="form-control-feedback">
                                            <img src="/images/company-icon.svg" alt='' />
                                        </span>
                                        <input type="text" autoComplete='off' className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Company name" value={this.state.email} onChange={(e) => this.onEmailChange(e)} onKeyPress={(e) => this.loginOnKeyPress(e)} />
                                    </div>
                                </div>
                                <div className="form-group" >
                                    <div className="has-search"  >
                                        <span className="form-control-feedback" >
                                            <img src="/images/name-icon.svg" alt='' />
                                        </span>
                                        <input type="text" className="form-control" autoComplete='off' placeholder="First name" onChange={(e) => this.onChangePassword(e)} onKeyPress={(e) => this.loginOnKeyPress(e)} />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="has-search"  >
                                        <span className="form-control-feedback" >
                                            <img src="/images/name-icon.svg" alt='' />
                                        </span>
                                        <input type="text" className="form-control" autoComplete='off' placeholder="Last name" onChange={(e) => this.onChangePassword(e)} onKeyPress={(e) => this.loginOnKeyPress(e)} />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="has-search"  >
                                        <span className="form-control-feedback" >
                                            <img src="/images/email-icon.svg" alt='' />
                                        </span>
                                        <input type="text" className="form-control" autoComplete='off' placeholder="Company email" onChange={(e) => this.onChangePassword(e)} onKeyPress={(e) => this.loginOnKeyPress(e)} />
                                    </div>
                                </div>
                                <div className="form-group" >
                                    <div className="has-search"  >
                                        <span className="form-control-feedback" style={{marginTop:8}} >
                                            <img src="/images/domain-icon.svg" alt='' />
                                        </span>
                                        <div className='d-flex align-items-center' >
                                            <input type="text" placeholder="Domain name" className='form-control mt-1' id="subdomain" />
                                            <input type="text" id="subdomaintwo" className='form-control mt-1' value=".elitelearning.io" disabled />
                                        </div>
                                        {/* <input type="text" className="form-control" autoComplete='off' placeholder="Domain name" onChange={(e) => this.onChangePassword(e)} onKeyPress={(e) => this.loginOnKeyPress(e)} /> */}
                                    </div>
                                </div>
                                <div className='form-group' >
                                    <button className='form-control button-color' style={{ borderRadius: 2, fontWeight: 500 }} onClick={() => this.goToAdd()}>Sign up</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>;
    }
}
